import { render, staticRenderFns } from "./Checkbox_comp.vue?vue&type=template&id=29adec9e&scoped=true&"
import script from "./Checkbox_comp.vue?vue&type=script&lang=js&"
export * from "./Checkbox_comp.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox_comp.vue?vue&type=style&index=0&id=29adec9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29adec9e",
  null
  
)

export default component.exports